import { Box } from '@chakra-ui/react';
import { Colors, Icon, Text } from '@mercator-gcp/grout';
import { Link as RouterLink } from 'react-router-dom';
import { useGroupConfigurations } from 'hooks/useGroupConfig';
import { useUser } from 'state/auth';
import type { SavedSearchChange } from 'services/API/AIInteractionAPI';

const cardStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 'padding_8',
  marginTop: 'padding_8',
  padding: '8px 12px',
  border: `1px solid ${Colors.ArmyGreen300}`,
  borderRadius: '8px',
  backgroundColor: Colors.White,
  textDecoration: 'none',
  color: Colors.ForestGreen900,
  '&:hover': {
    backgroundColor: Colors.ArmyGreen100,
  },
};

const ACTION_LABEL: Record<SavedSearchChange['action'], string> = {
  created: 'Saved search created',
  updated: 'Saved search updated',
  deleted: 'Saved search removed',
};

/**
 * Renders a link to the saved search a chat turn just created/updated, once
 * it's resolvable via the saved-search list (which has both adk_query_id and
 * the numeric group id the map's URL scheme needs). Deleted searches, or a
 * search not yet visible in that list, render nothing rather than a dead link.
 */
const SavedSearchChangeCard = ({ data }: { data: SavedSearchChange }) => {
  const { user } = useUser();
  const { data: groupConfigs } = useGroupConfigurations({ userId: String(user?.id) });
  const group = groupConfigs?.find((config) => config.adk_query_id === data.adk_query_id);

  if (data.action === 'deleted' || !group) {
    return null;
  }

  return (
    <Box as={RouterLink} to={`/projects?group=${group.id}`} sx={cardStyle}>
      <Icon name={Icon.Name.Map} size={16} fill={Colors.ForestGreen900} />
      <Text.Small>
        {ACTION_LABEL[data.action]}: {group.name}
      </Text.Small>
    </Box>
  );
};

export default SavedSearchChangeCard;
